"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.trackPageView = function (eventDef) {
  var trackers = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    trackers[_i - 1] = arguments[_i];
  }

  return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    var title = event.title,
        location = event.location,
        path = event.path,
        _a = event.fieldsObject,
        fieldsObject = _a === void 0 ? {} : _a;
    return __assign({
      type: 'page',
      trackingId: trackers,
      page_title: title,
      page_location: location,
      page_path: path
    }, fieldsObject);
  };
};

exports.trackEvent = function (eventDef) {
  return function (action, prevState, nextState) {
    var event = eventDef(action, prevState, nextState);
    var category = event.category,
        label = event.label,
        value = event.value,
        _a = event.fieldsObject,
        fieldsObject = _a === void 0 ? {} : _a;
    return __assign({
      type: 'event',
      action: event.action,
      event_category: category,
      event_label: label,
      value: value
    }, fieldsObject);
  };
};